import React from 'react'

export const UnsupportedQuestion = ({ question }) => (
  <div className="alert alert-warning">
    This question type ({question.type}) is not supported yet.
  </div>
)
